export default __webpack_public_path__ + "static/media/0007.23b6d87b.jpg";